import React, { useEffect, useState } from 'react';

import env from '../env';
interface FrontendVersionInfo {
  service: string;
  semver: string;
  fullSemVer: string;
  shortSha: string;
  buildId: string;
  buildDate: string;
  sourceBranch: string;
  repository: string;
}

export const VersionInfo: React.FC<{ collapse?: boolean }> = ({ collapse = true }) => {
  const [info, setInfo] = useState<FrontendVersionInfo | null>(null);
  const [opacity, setOpacity] = useState<number>(0.1);
  const [error, setError] = useState<string | null>(null);
  const [open, setOpen] = useState(!collapse);

  useEffect(() => {
    try {
      setInfo({
        service: 'webapp',
        semver: env.FUSION_OF_SEMVER,
        fullSemVer: env.FUSION_OF_FULLSEMVER,
        shortSha: env.FUSION_OF_SHORTSHA,
        buildId: env.FUSION_OF_BUILD_ID,
        buildDate: env.FUSION_OF_BUILD_DATE,
        sourceBranch: env.FUSION_OF_SOURCE_BRANCH,
        repository: env.FUSION_OF_REPO_NAME,
      });
    } catch (e) {
      setError('failed to read version info');
      return;
    }
  }, []);

  if (error) {
    return (
      <div style={{ fontSize: '0.75rem', opacity: 0.7 }}>version: error loading ({error})</div>
    );
  }
  if (!info) {
    return <div style={{ fontSize: '0.75rem', opacity: 0.5 }}>version: loading…</div>;
  }

  const body = (
    <table style={{ fontSize: '0.7rem', lineHeight: 1.2 }}>
      <tbody>
        <tr>
          <th style={{ textAlign: 'left', paddingRight: 4 }}>semver</th>
          <td>{info.semver}</td>
        </tr>
        <tr>
          <th style={{ textAlign: 'left', paddingRight: 4 }}>commit</th>
          <td>{info.shortSha}</td>
        </tr>
        <tr>
          <th style={{ textAlign: 'left', paddingRight: 4 }}>build</th>
          <td>{info.buildId}</td>
        </tr>
        <tr>
          <th style={{ textAlign: 'left', paddingRight: 4 }}>date</th>
          <td>{info.buildDate}</td>
        </tr>
        <tr>
          <th style={{ textAlign: 'left', paddingRight: 4 }}>branch</th>
          <td>{info.sourceBranch}</td>
        </tr>
      </tbody>
    </table>
  );

  if (!collapse) return body;

  return (
    <div
      style={{
        opacity: opacity,
        position: 'fixed',
        bottom: 4,
        right: 6,
        background: 'rgba(0,0,0,0.55)',
        color: '#fff',
        padding: '4px 6px',
        borderRadius: 4,
        zIndex: 100,
      }}
      onMouseEnter={() => setOpacity(1)}
      onMouseLeave={() => {
        setOpacity(0.1);
        setOpen(false);
      }}
    >
      <div
        style={{ cursor: 'pointer', fontSize: '0.65rem', fontWeight: 600 }}
        onClick={() => setOpen((o) => !o)}
      >
        build: {info.semver} ({info.shortSha}) {open ? '▼' : '▲'}
      </div>
      {open && body}
    </div>
  );
};

export default VersionInfo;
